<script>
  import svelteLogo from "./assets/svelte.svg";
  import viteLogo from "/vite.svg";
  import { onMount } from "svelte";
  import Map from "./lib/Map.svelte";
  import Stations from "./lib/Stations.svelte";
  import { selectedStation, ozoneValues } from "./store";
  import landkreiseData from "./assets/maps/lk-map-test-1.json";
  import allStationsData from "./assets/maps/stations.json";
  import bundeslaenderData from "./assets/maps/bl-test8.json";

  let stationsData = [];
  let loading = true;

  $: $selectedStation;

  // const dataUrl =
  //   "https://cdn.faz-azure.com/multimediaredaktion/Luftverschmutzung/linechart.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D";
  const dataUrl = import.meta.env.VITE_APP_DATA_URL;

  async function fetchOzoneData() {
    try {
      const response = await fetch(dataUrl); //fetch("/linechart.json");
      //console.log("Response:", response);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      //console.log("Ozonwerte geladen:", data);
      ozoneValues.set(data);
    } catch (error) {
      //console.error("Fehler beim Laden der Ozonwerte:", error);
    } finally {
      loading = false;
    }
  }

  onMount(() => {
    const interval = setInterval(fetchOzoneData, 60 * 60 * 1000); // Alle 60 Minuten
    fetchOzoneData(); // Initialer Aufruf
    return () => clearInterval(interval); // Aufräumen
  });

  fetchOzoneData();

  // Reactively filter stations when ozoneValues changes
  $: {
    if (!loading && $ozoneValues && Object.keys($ozoneValues).length > 0) {
      //console.log("Ozonwerte aktualisiert und Filterung wird durchgeführt:", $ozoneValues);
      stationsData = allStationsData.filter((station) => {
        const stationId = station.Station;
        return $ozoneValues[72] && $ozoneValues[72][stationId] !== undefined;
      });
      //console.log("Gefilterte Stationen:", stationsData);
    } else {
      //console.log("Ozonwerte noch nicht geladen oder leer, Stationen werden nicht gefiltert.");
      stationsData = [];
    }
  }
</script>

<h2>Die Ozonbelastung in Ihrer Region</h2>
<main>
  {#if loading}
    <p>Daten werden geladen...</p>
  {:else}
    <Map {landkreiseData} {bundeslaenderData} {stationsData} />
    <Stations {stationsData} />
  {/if}
</main>
<div class="footer">Grafik: jbel. / Quelle: Umweltbundesamt mit Daten der Messnetze der Länder und des Bundes</div>

<style>
</style>
